var map = {
	"./en-GB.json": [
		40454,
		[
			454
		]
	],
	"./es-ES.json": [
		19702,
		[
			702
		]
	],
	"./pt-BR.json": [
		82118,
		[
			118
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4726;
module.exports = webpackAsyncContext;